document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.testimonials-section');

  sliders.forEach((section) => {
    // Only init if slider logic is potentially active
    // We check via CSS state or simplified: if buttons exist
    const track = section.querySelector('.testimonials__track');
    const prevBtn = section.querySelector('.testimonials__nav-btn--prev');
    const nextBtn = section.querySelector('.testimonials__nav-btn--next');

    if (!track || !prevBtn || !nextBtn) return;

    // Scroll amount = width of one card + gap
    const getScrollAmount = () => {
      const card = track.querySelector('.testimonial-card');
      if (!card) return 0;
      // Approximate gap if flexible, but let's assume getComputedStyle or just card width
      // Better: width of card
      return card.offsetWidth + 24; // 24px gap assumption, better to read from style but this is safe for snap
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    // Optional: Toggle button visibility based on scroll position (intersection observer)
    // For now, simple scroll logic as requested.
  });
});
